import { CONTENT_TYPE } from "@/lib/static/content"
import { cn } from "@/lib/tailwind"
import type { ContentType } from "@prisma/client"
import { type VariantProps, cva } from "class-variance-authority"

export const CONTENT_TYPE_COLORS: Record<ContentType, string> = {
  DAILY: "cyan",
  INDUSTRY: "teal",
  INNOVATION: "green",
  MACROTREND: "red",
  MEGATREND: "orange",
  REGION: "green",
  REPORT: "blue",
  STAT: "purple",
  SUBTREND: "orange",
  TOPIC: "teal",
  GENERATION_RESULT: "teal",
}

export const tagStyles = cva("px-1.5 py-1 font-medium text-xs w-min whitespace-nowrap rounded-full", {
  variants: {
    type: {
      DAILY: "bg-cyan-400/40 dark:bg-cyan-400/20 text-cyan-900 dark:text-cyan-400",
      INDUSTRY: "bg-teal-400/40 dark:bg-teal-400/20 text-teal-900 dark:text-teal-400",
      INNOVATION: "bg-green-400/40 dark:bg-green-400/20 text-green-900 dark:text-green-400",
      MACROTREND: "bg-red-400/40 dark:bg-red-400/20 text-red-900 dark:text-red-400",
      MEGATREND: "bg-orange-400/40 dark:bg-orange-400/20 text-orange-900 dark:text-orange-400",
      REGION: "bg-green-400/40 dark:bg-green-400/20 text-green-900 dark:text-green-400",
      REPORT: "bg-blue-400/40 dark:bg-blue-400/20 text-blue-900 dark:text-blue-400",
      STAT: "bg-purple-400/40 dark:bg-purple-400/20 text-purple-900 dark:text-purple-400",
      SUBTREND: "bg-yellow-400/40 dark:bg-yellow-400/20 text-yellow-900 dark:text-yellow-400",
      TOPIC: "bg-teal-400/40 dark:bg-teal-400/20 text-teal-900 dark:text-teal-400",
      GENERATION_RESULT: "bg-teal-400/40 dark:bg-teal-400/20 text-teal-900 dark:text-teal-400",
    },
  },
  defaultVariants: {
    type: "INNOVATION",
  },
})

export type TagStyleProps = VariantProps<typeof tagStyles>

export function ContentTypeTag({ type = "INNOVATION", className, ...props }: TagStyleProps & { className?: string }) {
  return (
    <div {...props} className={cn(tagStyles({ type, className }))}>
      {CONTENT_TYPE[type!]}
    </div>
  )
}
